var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multi-select',{attrs:{"list-one-title":_vm.translations.available,"list-one":_vm.projectsAvailableFiltered,"list-two-title":_vm.translations.assigned,"list-two":_vm.projectsAssigned},on:{"updateList":_vm.updateList}})
}
var staticRenderFns = []

export { render, staticRenderFns }